import queryString from 'query-string';
import { AxiosResponse } from 'axios';
import HttpClient, { Metadata } from '../utils/HttpClientHandler';
import { Stack } from '../types/Stack';
import PaginationHandler from '../utils/PaginationHandler';

const StackService = class StackService {
    #baseURL: string;

    constructor() {
        this.#baseURL = '/stack';
    }

    // @christianjtr : Should be an utils function...
    private setQueryStringParams(filters: { [key: string]: any }): string {
        return queryString.stringify(filters, { arrayFormat: 'comma', skipEmptyString: true, skipNull: true });
    }

    public async getAllStacks(filters = {}): Promise<{ data: Stack[] | any[]; _metadata: Metadata }> {
        const qsFilters = Object.keys(filters).length !== 0 ? `?${this.setQueryStringParams(filters)}` : '';
        const response: AxiosResponse = await HttpClient.get(`${this.#baseURL}${qsFilters}`);

        const { data, headers }: { data: Stack[]; headers: any } = response;

        return {
            data: data.map((stack, index) => ({ key: index, ...stack })),
            _metadata: {
                pagination: new PaginationHandler(headers),
            },
        };
    }

    public async getStackById(stackId: number): Promise<Stack | any> {
        const response: AxiosResponse = await HttpClient.get(`${this.#baseURL}/${stackId}`);
        const { data }: { data: Stack } = response;
        return data;
    }
};

export default new StackService();
